import { render } from "./InfrastructureDetails.vue?vue&type=template&id=ec110ece"
import script from "./InfrastructureDetails.vue?vue&type=script&lang=js"
export * from "./InfrastructureDetails.vue?vue&type=script&lang=js"

import "./InfrastructureDetails.vue?vue&type=style&index=0&id=ec110ece&lang=css"

import exportComponent from "/tmp/build_ada65e43/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__